import { type ScorecardTest, type Verdict } from './types';

export const VERDICT_LABELS: Record<Verdict, string> = {
  pass: 'Pass',
  fail: 'Fail',
  'not-shown': 'Not shown',
};

export const VERDICT_ORDER: Verdict[] = ['pass', 'fail', 'not-shown'];

/**
 * The 12 tests, grouped by pillar. Content lives here (frontend-owned); the
 * server renders whatever is POSTed, so copy can change without PHP edits.
 */
export const SCORECARD_TESTS: ScorecardTest[] = [
  { n: 1, pillar: 'Retrieval', test: 'Messy tenant', essential: false },
  { n: 2, pillar: 'Retrieval', test: 'Vocabulary gap', essential: false },
  { n: 3, pillar: 'Retrieval', test: 'Unindexed source', essential: false },
  { n: 4, pillar: 'Trust', test: 'Citation', essential: false },
  { n: 5, pillar: 'Trust', test: 'Permission leak', essential: true },
  { n: 6, pillar: 'Trust', test: '“I don’t know”', essential: true },
  { n: 7, pillar: 'Relevance', test: 'Two employee', essential: true },
  { n: 8, pillar: 'Relevance', test: 'Right-time', essential: false },
  { n: 9, pillar: 'Relevance', test: 'Unasked question', essential: false },
  { n: 10, pillar: 'Operation', test: 'Ownership', essential: false },
  { n: 11, pillar: 'Operation', test: 'Admin load', essential: false },
  { n: 12, pillar: 'Operation', test: 'Action and audit', essential: false },
];
